import { createSlice } from '@reduxjs/toolkit';
import { logOutUser } from './userSlice';

const initialState = {
    isPunchOut: false,
    sessionId: '',
    provider: '',
    basketId: '',
    // create | edit | inspect
    operation: 'create',
    // derived from operation: whether the cart may be modified / returned
    canModify: true,
    canReturn: true
};

// create/edit can modify + return the cart; inspect is strictly read-only.
const deriveCapabilities = (operation) => {
    const op = (operation ?? 'create').toString().toLowerCase();
    const editable = op === 'create' || op === 'edit';
    return { canModify: editable, canReturn: editable };
};

export const punchoutSlice = createSlice({
    name: 'punchout',
    initialState,
    reducers: {
        setPunchOut: (state, action) => {
            const payload = action.payload ?? {};
            const operation = (payload.operation ?? 'create').toString().toLowerCase();
            const { canModify, canReturn } = deriveCapabilities(operation);
            state.isPunchOut = payload.isPunchOut ?? true;
            state.sessionId = payload.sessionId ?? '';
            state.provider = payload.provider ?? '';
            state.basketId = payload.basketId ?? '';
            state.operation = operation;
            state.canModify = canModify;
            state.canReturn = canReturn;
        },
        clearPunchOut: () => ({ ...initialState })
    },
    extraReducers: (builder) => {
        // Never let a PunchOut flag leak into a later normal (non-PunchOut) session.
        builder.addCase(logOutUser, () => ({ ...initialState }));
    }
});

export const { setPunchOut, clearPunchOut } = punchoutSlice.actions;
export const punchoutActions = punchoutSlice.actions;
export default punchoutSlice.reducer;
